import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ProceduresDTO } from '../company-user/userProfileDTO.model';
import { EquipmentDTO } from '../Models/Equipment.model';
import { ProcedureDTO, TemplateDTO, UserProcedureDataDTO, ProcedureOrigin } from '../Models/Procedure.model';
import { SpecialityDTO } from '../Models/Speciality.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { SrubUpService } from '../Services/ScrubUp.service';
import { UserService } from '../Services/user.service';
import { ContactsDTO, MyContactsDTO, ShareProcedureToContactsDTO } from '../Models/Contact.model';
import {environment} from '../../environments/environment';
declare var swal: any;
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-procedure',
  templateUrl: './procedure.component.html',
  styleUrls: ['./procedure.component.scss'],
  providers: [SrubUpService, UserService]
})
export class ProcedureComponent implements OnInit {
  image:any;
  categoryequipmentsList:any=[];
  ecidArray:any=[];
  qtyFlag=false;
  qtyMsg:any;
  imageUrl:any;
  equipmentNameMsg:any;
  equipmentCatMsg:any;
  equipmentCatFlag=false;
  equipmentFlag=false;
  specificationFlag=false;
  specificationMsg:any;

  procedureForm: FormGroup;
  submitted = false;
  display='none'; //default Variable
  uploadUrl: string;

  public baseurl: string = environment.base_url;
  equipmentName: string;
  specification: string;

  quantity: any;
  imagePath: string;
  categoryName: string;

  chooseEquipment: string;
  chooseSpecification: string;
  equpimage:string;

  sharedUserInfo: MyContactsDTO;
  procedureToShare: ProcedureDTO;
  contacts: ContactsDTO;
  myContactsList: Array<MyContactsDTO>;
  shareProcedureToContactsList: Array<ShareProcedureToContactsDTO>;
  shareProcedureToContact: ShareProcedureToContactsDTO;
  shareProcedureToUserIds: Array<number>;

  loginUserId: number;
  showAssignEquipment: boolean;
  detailViewIcon: number;
  equipmentEditView: boolean;
  selectedProcSpeciality: string;
  selectedProcedureName: string;
  fullEquipmentsList: Array<EquipmentDTO>;
  specialityName:any;
  equipmentcategories: Array<string>;
  choosenCategoryEquipments: Array<string>;
  choosenEquipmentSpecifications: Array<string>;

  assignedEquipmentcategories: Array<EquipmentDTO>;
  categoryequipments: Array<EquipmentDTO>;
  userProcedureData: UserProcedureDataDTO;

  procedureName: string;
  description: string;
  specialityId: number;
  procedures: Array<ProcedureDTO>;
  specialities: Array<SpecialityDTO>;
  procedureArray:any={};

  codeValue: string;
  descriptionValue: string;
  iValue: number;
  showEditingDiv: number;
  step: string;
  jindex:string;
  //showDetails;
  universalHideAndShowMpId;
  isMobile;
  deviceOfflineColm: boolean;
  index: boolean;
  edit: boolean;

  userId: number;
  editimageUrl:any=[];
  selectedRoles: Array<string>;
  public loading = false;
  showAlreadyExist: boolean;

  procedure: ProceduresDTO;

  httpClient: any;
  addImageInvisible: number;
  addChecklistItem: number;
  selectedProcedureId: any;
  category: number;
  createProcedure: number;
  isImpersonateMode: boolean;
  getAdminValues: boolean;
  specialityIdForProcedureDisplay: number;
  addEquipmnt: boolean;
  quantityVal ="quantity";

  imageUploadApiUrlLength: number;
  myHeaders: { [name: string]: any };
  tempUrl: Array<string>;
  specialityIdArray:any={};

  constructor(private formBuilder: FormBuilder,public route:ActivatedRoute,private userService: UserService, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
   if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
        this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.chooseEquipment = "select";
    this.chooseSpecification = "select";
    this.addEquipmnt = false;
    this.specialityIdForProcedureDisplay = -1;
    
    this.getAdminValues = false;

    this.isImpersonateMode = Globals.ImpersonationValue;
    this.loginUserId = this.appUser.UserId;

    this.procedures = new Array<ProcedureDTO>();
    this.specialities = new Array<SpecialityDTO>();
    this.equipmentcategories = new Array<string>();
    this.choosenCategoryEquipments = new Array<string>();
    this.choosenEquipmentSpecifications = new Array<string>();
    this.assignedEquipmentcategories = new Array<EquipmentDTO>();
  

    this.showAssignEquipment = false;
    this.detailViewIcon = -1;
    this.equipmentEditView = false;

    this.iValue = -1;
    this.showEditingDiv = -1;
    this.addImageInvisible = 0;
    this.addChecklistItem = 0;

    this.universalHideAndShowMpId = 0;
    this.deviceOfflineColm = true;

    this.index = true;


    // this.uploadUrl = this.baseurl + "api/Speciality/UploadImage?userId=" + this.loginUserId;

    // this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
    // this.myHeaders = {
    // };

   
    this.tempUrl = new Array<string>();

  }
  checkExtension(file: any) {
    let mimeType = ['image/png', 'image/jpeg', 'image/jpg'];
    return mimeType.indexOf(file.type);
  }
  OnUploadFinished($event: any,j:any) {
   // console.log(j);
    let uploadStatus: string;
    const files = $event.target.files || $event.srcElement.files;
    const file = files[0];
    const type = this.checkExtension(file);
    if (file && type != -1) {
      this.image = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        this.editimageUrl[j] = event.target.result;
      };
    } else {
    }
  

  }
 

  CancelAddEquipment() {
    this.display="none";
    this.addEquipmnt = false;
  }
 
  AddEquipment() {

    if(this.categoryName=="" || this.categoryName==undefined)
    {
      this.equipmentCatFlag = true;
      this.equipmentCatMsg = "please select Equipment Category"
      return;
    }
    else{
      this.equipmentCatFlag = false;
    }
    if(this.equipmentName == "" || this.equipmentName==undefined)
    {
      this.equipmentFlag=true;
      this.equipmentNameMsg="please enter Equipment Name";
      return;
    }
    else
    {
      this.equipmentFlag=false;
    }
    if(this.specification == "" || this.specification==undefined)
    {
      this.specificationFlag=true;
      this.specificationMsg="please enter Equipment Name";
      return;
    }
    else
    {
      this.specificationFlag=false;
    }

    if(this.quantity == null || this.quantity==undefined)
    {
      this.qtyFlag=true;
      this.qtyMsg="please enter Quantity";
      return;
    }
    else
    {
      var qty =this.quantity; 
      this.qtyFlag=false;
      // var regexp ='[0-9]*(\.[0-9]{0,2})?$';
    //  var regexp = '/^([0-9])*(.[0-9]{0,2})?$/i';
      // let checkqtyformat = qty.search(regexp);
      
     //console.log(new RegExp('^([0-9]+)*([.][0-9]{0,2})?$').test(qty.toString()));
      if(!new RegExp('^([0-9]+)*([.][0-9]{0,2})?$').test(qty.toString()))
      {
        return ;
      }
      
      
    }
   
    let quantity:any = this.quantity;
    this.loading = true;
    let formData = new FormData();
    formData.append('UEID','0');
    formData.append('ECID',this.categoryName);
    formData.append('EquipmentName',this.equipmentName);
    formData.append('Specification',this.specification);
    formData.append('Quantity',quantity);
    formData.append('UserProcedureID',Globals.PId);
    formData.append('ImageFile',this.image);
    this.scrubUpService.AddUserEquipment(this.token,formData).subscribe(x => {
      if (x.Status == true) {
        this.getEquipChecklistDetails(Globals.SpecialityId, Globals.PId, Globals.CategoryId, this.selectedProcedureName);
        this.equipmentName = "";
        this.specification = "";
        this.quantity = null;
        swal({
          title: 'Equipment Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.display="none";
        this.image='';
        this.imageUrl='';
        this.editimageUrl='';
       
      }
      else {

      }
      this.loading = false;
    },
    error => {
      // console.log(error);
      // this.router.navigate(['login']);
      // this.display="none";
      // this.image='';
      // this.imageUrl='';
      // this.editimageUrl='';
      this.loading = false;
    });

  }

  addEquipmentShow() {
    this.equpimage = "";
    this.image='';
    this.imageUrl='';
    this.equipmentName = "";
    this.specification = "";
    this.chooseEquipment="";
    this.categoryName="";
    this.chooseSpecification="";
    this.quantity = null;
    this.addEquipmnt = true;
    this.display="block";
  }

  SaveEquipmentsList() {
    let userProcObJ: UserProcedureDataDTO;
    userProcObJ = new UserProcedureDataDTO();
    userProcObJ.SpecialityId = this.specialityId;
    userProcObJ.ProcedureId = this.selectedProcedureId;
    userProcObJ.UserId = this.loginUserId;
    userProcObJ.Template = new TemplateDTO();
    userProcObJ.Template = this.userProcedureData.Template;
    userProcObJ.Equipments = new Array<EquipmentDTO>();
    userProcObJ.Equipments = this.userProcedureData.Equipments;
    userProcObJ.Equipments = this.assignedEquipmentcategories.filter(equipment => equipment.IsChecked === true)
    this.loading = true;
    this.scrubUpService.AssignEquipments(this.token, userProcObJ, this.appUser.UserId).subscribe(x => {
      if (x == "success") {
      this.GetOnlySpecialityProcedures();
     
      swal({
        title: 'Equipments Saved Successfully',
        type: "success",
        timer: 2000,
        showConfirmButton: false
      }).catch(swal.noop);

    }
      this.loading = false;
   
  },
  error => {
    // console.log(error);
    // this.router.navigate(['login']);
    // this.display="none";
    // this.image='';
    // this.imageUrl='';
    // this.editimageUrl='';
    this.loading = false;
  });
  }

  cancelAssignEquipmentChanges() {
    this.equipmentEditView = false;
    this.showEditingDiv = -1;
    this.detailViewIcon = -1;
    this.index = true;
    this.showAssignEquipment = false;
  }

  // ShareIt(index) {

  //   this.procedureToShare = new ProcedureDTO;
  //   this.procedureToShare = this.procedures[index];
  //   this.selectedProcedureId = this.procedureToShare.ID;
  //   this.specialityId = this.procedureToShare.SpecialityID;
  // }

  // ShareProcedure() {
  //   this.shareProcedureToUserIds = new Array<number>();
  //   this.shareProcedureToContactsList.forEach(element => {
  //     if (element.IsChecked) {
  //       this.shareProcedureToUserIds.push(element.UserId);
  //     }
  //   });
  //   if (this.shareProcedureToUserIds.length > 0) {
  //     this.loading = true;
  //     let SharedAtDateTime: string;
  //     SharedAtDateTime = new Date().toLocaleString();
  //     this.scrubUpService.ShareProcedure(this.token, this.shareProcedureToUserIds, this.specialityId, this.selectedProcedureId, this.loginUserId,SharedAtDateTime).subscribe(x => {
  //       if (x == "success") {
  //         swal({
  //           title: 'Shared with selected contacts.',
  //           type: "success",
  //           timer: 2000,
  //           showConfirmButton: false
  //         }).catch(swal.noop);
  //       }
  //       else {

  //       }
  //       this.loading = false;
  //     });
  //   }
  //   else { return; }
  // }
  editEquipment(editableCategoryindex,UEID,EquipmentName,Specification,Quantity,ECID) {

    
    if(EquipmentName== "" || EquipmentName==undefined)
    {
      this.equipmentFlag=true;
      this.equipmentNameMsg="please enter Equipment Name";
      return;
    }
    else
    {
      this.equipmentFlag=false;
    }
    if(Specification == "" || Specification==undefined)
    {
      this.specificationFlag=true;
      this.specificationMsg="please enter Equipment Name";
      return;
    }
    else
    {
      this.specificationFlag=false;
    }

    if(Quantity== null ||Quantity==undefined ||Quantity==0 || Quantity=='')
    {
      this.qtyFlag=true;
      this.qtyMsg="please enter Quantity";
      return;
    }
    else
    {
      this.qtyFlag=false;
      var qty =Quantity; 
     // console.log(new RegExp('^([0-9]+)*([.][0-9]{0,2})?$').test(qty.toString()));
      if(!new RegExp('^([0-9]+)*([.][0-9]{0,2})?$').test(qty.toString()))
      {
        return ;
      }
   
    }
   
    let formData = new FormData();
    formData.append('UEID',UEID);
    formData.append('ECID',ECID);
    formData.append('EquipmentName',EquipmentName);
    formData.append('Specification',Specification);
    formData.append('Quantity',Quantity);
    formData.append('UserProcedureID',Globals.PId);
    formData.append('ImageFile',this.image);
    this.scrubUpService.AddUserEquipment(this.token,formData).subscribe(x => {
      if (x.Status == true) {
        swal({
          title: 'Equipment updated Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.display="none";
        this.image='';
        this.imageUrl='';
        this.editimageUrl='';
      }
      else {
      }
      this.getAssignedEquipmentList(Globals.PId)
      this.loading = false;
  
  },
  error => {
    this.getAssignedEquipmentList(Globals.PId);
    this.loading = false;
  });
  }
  
  markDeleteEquipment(index, toDeleteID) {

    swal({
      title: 'Are you sure you want to Delete this ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      this.scrubUpService.DeleteAssignEquipment(this.token,toDeleteID).subscribe(x => {
       // console.log(x);
            if (x == true) {
              swal({
                title: 'Equipment Deleted Successfully',
                type: "success",
                timer: 2000,
                showConfirmButton: false
              }).catch(swal.noop);
              this.cancelAddProc();
            //  this.GetProcedures();
            }
            else if (x == false) {
              swal({
                title: 'Deletion Failed!!',
                type: "info",
                timer: 2000,
                showConfirmButton: false
              }).catch(swal.noop);
            }
            else {

            }
            this.getAssignedEquipmentList(Globals.PId);
            this.loading = false;
      },
        error => {
          this.getAssignedEquipmentList(Globals.PId);
          this.loading = false;
        })

    }).catch(swal.noop);


  }
  viewEquipmentDetails(index: number, categoryName: string) {

    this.tempUrl = [];
    this.equipmentEditView = false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
        this.detailViewIcon = -1;
        this.iValue = -1;
      }
      else {
        this.categoryequipments = new Array<EquipmentDTO>();
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.detailViewIcon = index;
        this.iValue = index;
      }
    }
    else {
      this.categoryequipments = new Array<EquipmentDTO>();
      this.showEditingDiv = index;
      this.detailViewIcon = index;
      this.iValue = index;
    }
  }

  SetProcedureId(specialityId: number, pId: string, categoryId: number) {
    Globals.PId = pId;
    Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
    Globals.LoginUsrId = this.loginUserId;
  }

  getEquipChecklistDetails(specialityId: number, pId: string, categoryId: number,procedurename) {
    Globals.PId=pId;
    this.selectedProcedureId = pId;
    Globals.PId = pId;
    this.specialityId = specialityId;
    Globals.SpecialityId = specialityId;
    Globals.CategoryId = categoryId;
   //var x = this.findObjectByKey(this.procedures, 'ID', this.selectedProcedureId);
     this.selectedProcedureName = procedurename;
    this.selectedProcSpeciality = this.cookieService.get('specialityName');

    this.getEquipmentCategoryList();
    //this.getEquipmentList();
    this.getAssignedEquipmentList(pId);
  }

  mapAssignedEquipments() {
    for (let x = 0; x < this.fullEquipmentsList.length; x++) {
      if (this.assignedEquipmentcategories == null) {
        this.assignedEquipmentcategories = [];
        return;
      }
      for (let y = 0; y < this.assignedEquipmentcategories.length; y++) {
        if (this.fullEquipmentsList[x].ID == this.assignedEquipmentcategories[y].ID) {
          this.fullEquipmentsList[x] = this.assignedEquipmentcategories[y];
        }
      }
    }
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }

  cancelAddProc() {
    this.display="none";
    this.specialityId=0;
    this.procedureName="";
    this.description="";
    this.createProcedure = 0;
  }
  closeModalDialog()
  {

    this.display='none'; //set none css after close dialog
  }
  UserClick(btnCount) {
   // console.log("123");
    this.index = false;
    this.edit = false;
    if (btnCount == 0) {
      this.display='block'; //Set block css
      this.procedureForm.controls['specialityId'].setValue('');
      this.procedureForm.controls['procedureName'].setValue('');
      this.procedureForm.controls['description'].setValue('');
     // this.specialityIdForProcedureDisplay = -1;
      this.createProcedure = 1;
      this.index = true;
      this.edit = false;
    }
    if (btnCount == 1) {
      this.index = true;
      this.edit = false;
      this.selectedProcedureId = 0;
      this.category = 0;
    }
    if (btnCount == 2) {
      this.index = false;
      this.edit = true;
    }
    if (btnCount == 3) {
      this.edit = true;
      this.addImageInvisible = 1;
    }
    if (btnCount == 4) {
      this.showAssignEquipment = true;
      this.index = false;
      this.edit = false;
    }
  }

  ngOnInit() {
    this.GetSpecialities();
    this.GetContactsInfo();
    this.procedurevalidation();
  }
  procedurevalidation()
  {
    this.procedureForm = this.formBuilder.group({
      procedureName: ['',Validators.required],
      description: ['', Validators.required],
      specialityId:['', Validators.required]
    });
  }
  get f() { return this.procedureForm.controls; }
  setSpecificationValue() {
    this.specification = this.chooseSpecification;
  }
  getCategoryEquipments() {
    this.loading = true;
    this.scrubUpService.GetSelectedCategoryEquipments(this.token, this.loginUserId, this.categoryName).subscribe(x => {
   if (x != null && x != undefined) {
        this.choosenCategoryEquipments = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  getEquipmentSpecifications() {

    this.equipmentName = this.chooseEquipment;
    this.loading = true;
    this.scrubUpService.GetSelectedEquipmentSpecifications(this.token, this.loginUserId, this.categoryName, this.chooseEquipment).subscribe(x => {
      if (x != null && x != undefined) {
        this.choosenEquipmentSpecifications = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  GetOnlySpecialityProcedures() {

    this.procedures=[];
    this.loading = true;
    this.getAdminValues = true;
    this.specialityIdArray={
      "UserSpecialityID": this.specialityIdForProcedureDisplay,
    }
    this.scrubUpService.GetOnlySpecialityProcedures(this.token, this.specialityIdArray).subscribe(x => {
   if (x.Status == true) {
    this.procedures = x.Data;
    }
    this.loading = false;
  },
  error => {
    this.loading = false;
  })
      }


  specialitySelectedForProcedures() {
   for(var i=0;i< this.specialities.length;i++)
   {
    if(this.specialities[i]['ID']==this.specialityIdForProcedureDisplay)
    {
      this.cookieService.set("specialityName",this.specialities[i]['Name']);
    }
   }
    this.GetOnlySpecialityProcedures();
  }

  GetContactsInfo() {
    this.shareProcedureToContactsList = new Array<ShareProcedureToContactsDTO>();
    this.loading = true;
    this.scrubUpService.GetContactsInfo(this.token, this.loginUserId).subscribe(x => {
      if (x != null && x != undefined) {
        this.contacts = x;
        if (x.MyContacts != null && x.MyContacts != undefined) {
          this.myContactsList = this.contacts.MyContacts;
          this.myContactsList.forEach(element => {
            this.shareProcedureToContact = new ShareProcedureToContactsDTO;
            this.shareProcedureToContact.UserId = element.UserId;
            this.shareProcedureToContact.Name = element.Name;
            this.shareProcedureToContact.MobileNumber = element.MobileNumber;
            this.shareProcedureToContact.Email = element.Email;
            this.shareProcedureToContact.IsChecked = false;
            this.shareProcedureToContactsList.push(this.shareProcedureToContact);
          });
        }
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }


  //category list
  getEquipmentCategoryList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentCategoryList(this.token, this.loginUserId).subscribe(x => {
 
      if (x['Data'] != null && x.Status == true) {
        this.equipmentcategories = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  //equipment list
  getEquipmentList() {
    this.loading = true;
    this.scrubUpService.GetEquipmentList(this.token, this.loginUserId).subscribe(x => {
      if (x != null && x != undefined) {
        this.fullEquipmentsList = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  getAssignedEquipmentList(pid) {
    this.categoryequipmentsList=[];
    this.imageUrl='';
    this.ecidArray = [];
    this.scrubUpService.GetAssignedEquipmentsList(this.token, pid).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true) {
        let assequp = x['Data'];
       
        for(var i=0;i<assequp.length;i++)
      {
        for(var j=0;j<assequp[i]['UserEquipmentList'].length;j++)
        {
          this.categoryequipmentsList.push(assequp[i]['UserEquipmentList'][j]);
          this.ecidArray.push(assequp[i]['UserEquipmentList'][j]['ECID']);
        }
      }
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
      //console.log( this.ecidArray);
  }

  GetProcedures() {
    this.loading = true;
  }

  GetSpecialities() {
    this.loading = true;
    this.scrubUpService.GetSpecialities(this.token, this.loginUserId, this.getAdminValues).subscribe(x => {

      if (x['Data'] != null && x != undefined) {
        this.specialities = x['Data'];
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }


  ShowSharedByInfo(sharedByUserId,dateTime) {
    let sharedAtDtTime:string;
    sharedAtDtTime = new Date(dateTime).toLocaleString();
    this.sharedUserInfo = new MyContactsDTO();
    this.sharedUserInfo = this.findObjectByKey(this.myContactsList, 'UserId', sharedByUserId);
    if (this.sharedUserInfo != null) {
      swal(
        {
          text: "Procedure shared by ...",
          html: '<div class="well"><label style="font-size:18px;">Shared user info...</label><hr><strong style="font-size:18px;">User Name : </strong>' + this.sharedUserInfo.Name + '<br><br>' +
            '<strong style="font-size:18px;">Email_Id : </strong>' + this.sharedUserInfo.Email + '<br><br>' +
            '<strong style="font-size:18px;">Mobile Number : </strong>' + this.sharedUserInfo.MobileNumber + '<br><br><label style="font-size:12px;text-align:left;">'+sharedAtDtTime +'</label></div>'
        }
      ).catch(swal.noop);
    }
    else {
      swal(
        {
          text: "missing contact info"
        }
      ).catch(swal.noop);
    }
  }

  AddProcedure() {
    this.submitted = true;
    if (this.procedureForm.invalid) {
      return;
  }

    this.procedureArray.UserSpecilalityID=this.procedureForm.controls['specialityId'].value;
    this.procedureArray.UserProcedureID=0;
    this.procedureArray.Name=this.procedureForm.controls['procedureName'].value;
    this.procedureArray.Description=this.procedureForm.controls['description'].value;

    this.loading = true;
    this.scrubUpService.AddProcedure(this.token,this.procedureArray).subscribe(x => {
   // console.log(x);
      if (x.Status == true) {
        this.cancelAddProc();
       this.specialityIdForProcedureDisplay =this.procedureForm.controls['specialityId'].value; 
       this.specialityIdForProcedureDisplay=this.specialityIdForProcedureDisplay;
       this.GetOnlySpecialityProcedures();
        swal({
          title: 'Procedure Created Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.display="none";
      }
      else if (x.Status == false) {
        swal({
          title: 'Procedure Already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);
        this.display="none";
      }
      else {

      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      });

  }

  DeleteProcedure(UserSpecialityID: any,UserProcedureID:any) {
   let deleteSpecArray={
     "UserProcedureID":UserProcedureID,
     "UserSpecilalityID":UserSpecialityID
   };

    swal({
      title: 'Are you sure you want to Delete this Procedure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      this.scrubUpService.DeleteProcedures(this.token, deleteSpecArray).subscribe(x => {
       // console.log(x);
            if (x == true) {
              swal({
                title: 'Procedure Deleted Successfully',
                type: "success",
                timer: 2000,
                showConfirmButton: false
              }).catch(swal.noop);
              this.cancelAddProc();
            //  this.GetProcedures();
            }
            else if (x == false) {
              swal({
                title: 'Deletion Failed!!',
                type: "info",
                timer: 2000,
                showConfirmButton: false
              }).catch(swal.noop);
            }
            else {

            }
            this.GetOnlySpecialityProcedures();
            this.loading = false;
      },
        error => {
          this.loading = false;
        })
    }).catch(swal.noop);





  //   this.loading = true;
  //   this.scrubUpService.DeleteProcedures(this.token, this.procedures[index].ID, this.procedures[index].SpecialityID, this.appUser.UserId, this.procedures[index].DuplicateSharedProcedureID).subscribe(x => {
  //     if (x == "success") {
  //       swal({
  //         title: 'Procedure Deleted Successfully',
  //         type: "success",
  //         timer: 2000,
  //         showConfirmButton: false
  //       }).catch(swal.noop);
  //       this.cancelAddProc();
  //       this.GetProcedures();
  //     }
  //     else if (x == "Failure") {
  //       swal({
  //         title: 'Deletion Failed!!',
  //         type: "info",
  //         timer: 2000,
  //         showConfirmButton: false
  //       }).catch(swal.noop);
  //     }
  //     else {

  //     }
  //     this.loading = false;
  //   },
  //     error => {
  //       this.loading = false;
  //     });
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/procedure/procedure.component.ts